import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from './toast.service';


/**
 * Toast component to display feedback messages.
 */
@Component({
	selector: 'app-toast',
	imports: [
		NgbToastModule
	],
	templateUrl: './toast.component.html',
	host: { '[class.ngb-toasts]': 'true' },
	changeDetection: ChangeDetectionStrategy.Eager
})
export class ToastComponent {

	public toastSrv = inject(ToastService);

}
